import axios from "axios";
import { API_BASE } from "../config/constants";

export const publicationCategoryResource = axios.create({
  baseURL: `${API_BASE}/api/v1/publication-category`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const ordersResource = axios.create({
  baseURL: `${API_BASE}/api/v1/publication-orders`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 58c02f1b-b9e5-49b0-af91-7d86ef036292",
  },
});

export const paymentResource = axios.create({
  baseURL: `${API_BASE}/api/v1/payment`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const authorizationResource = axios.create({
  baseURL: `${API_BASE}/api/v1/authorization/publication-orders`,
  headers: {
    "Content-Type": "application/json",
  },
});
